<template>
    <div class="d-flex justify-content-center align-items-center min-vh-100">
        <div class="container-box">
            <div :class="['forms-column', isLoginActive ? 'login-narrow' : 'register-wide']">
                <div class="fo">
                    <div class="form-header" style="padding-top:0!important; margin-top:0!important;">
                        <img src="@/assets/images/logo_iacd.png" alt="logo" class="logo-img" v-if="isLoginActive">
                        <h3 class="fw-bold mb-4">{{ isLoginActive ? "Connectez-vous" : "Inscrivez-vous" }}</h3>
                    </div>
                    <div class="stepper d-flex justify-content-center align-items-center mb-4" v-if="!isLoginActive">
                        <div class="step" :class="{ active: currentStep >= 1, completed: currentStep > 1 }">
                            <div class="step-circle">1</div>
                            <span class="step-label">Informations Générales</span>
                        </div>
                        <div class="step-line"></div>
                        <!-- <div class="step" :class="{ active: currentStep >= 2, completed: currentStep > 2 }">
                            <div class="step-circle">2</div>
                            <span class="step-label">Coordonnées & <br> Localisation</span>
                        </div> -->
                        <div class="step" :class="{ active: currentStep >= 2, completed: currentStep > 2 }">
                            <div class="step-circle">2</div>
                            <span class="step-label">Informations Légales & Sécurité</span>
                        </div>
                        <div class="step-line"></div>
                        <div class="step" :class="{ active: currentStep >= 3, completed: currentStep > 3 }">
                            <div class="step-circle">3</div>
                            <span class="step-label">Récapitulatif & Confirmation</span>
                        </div>
                    </div>
                    <div class="form-content">
                        <transition name="fade">
                            <div v-if="globalSuccess"
                                class="alert alert-success d-flex align-items-center mb-4 rounded-3" role="alert">
                                <i class="bi bi-check-circle-fill me-2"></i>
                                <div class="fw-medium">{{ globalSuccess }}</div>
                            </div>
                        </transition>

                        <!-- MESSAGE D'ERREUR GLOBAL (auto-disparition) -->
                        <transition name="fade">
                            <div v-if="globalError" class="alert alert-danger d-flex align-items-center mb-4 rounded-3"
                                role="alert">
                                <i class="bi bi-exclamation-triangle-fill me-2"></i>
                                <div class="fw-medium">{{ globalError }}</div>
                            </div>
                        </transition>
                        <transition name="slide-fade" mode="out-in">
                            <div>
                                <Form v-if="!isLoginActive" ref="registerForm" @submit="onSubmitRegister"
                                    :validation-schema="registerSchema">
                                    <div class="form-box register-box">
                                        <!-- Étape 1 fusionnée (infos personnelles + coordonnées) -->
                                        <div v-show="currentStep === 1" class="row g-3">
                                            <div class="col-sm-4">
                                                <Field name="nom" type="text" class="form-control" placeholder="Nom" />
                                                <ErrorMessage name="nom" class="text-danger" />
                                            </div>
                                            <div class="col-sm-4">
                                                <Field name="prenom" type="text" class="form-control"
                                                    placeholder="Prénom" />
                                                <ErrorMessage name="prenom" class="text-danger" />
                                            </div>
                                            <div class="col-sm-4">
                                                <Field name="email" type="text" class="form-control"
                                                    placeholder="Email" />
                                                <ErrorMessage name="email" class="text-danger" />
                                            </div>
                                            <div class="col-sm-4">
                                                <Field name="statut" v-slot="{ field }">
                                                    <Multiselect :options="statutOptions" v-model="field.value"
                                                        v-bind="field" placeholder="Statut" />
                                                </Field>
                                                <ErrorMessage name="statut" class="text-danger" />
                                            </div>
                                            <div class="col-sm-4">
                                                <Field name="nomOrganisation" type="text" class="form-control"
                                                    placeholder="Nom de l'organisation" />
                                                <ErrorMessage name="nomOrganisation" class="text-danger" />
                                            </div>
                                            <div class="col-sm-4">
                                                <Field name="siteweb" type="text" class="form-control"
                                                    placeholder="Site web de l'organisation" />
                                                <ErrorMessage name="siteweb" class="text-danger" />
                                            </div>
                                            <div class="col-sm-4">
                                                <Field name="adresse" type="text" class="form-control"
                                                    placeholder="Adresse" />
                                                <ErrorMessage name="adresse" class="text-danger" />
                                            </div>
                                            <div class="col-sm-4">
                                                <Field name="ville" type="text" class="form-control"
                                                    placeholder="Ville" />
                                                <ErrorMessage name="ville" class="text-danger" />
                                            </div>
                                            <div class="col-sm-4">
                                                <Field name="codePostal" type="text" class="form-control"
                                                    placeholder="Code postal" />
                                                <ErrorMessage name="codePostal" class="text-danger" />
                                            </div>
                                            <div class="col-sm-4">
                                                <Field name="pays" v-slot="{ errors }">
                                                    <Vue3CountryIntl @change="onCountryChange"
                                                        placeholder="Sélectionnez votre pays" :showCode="false"
                                                        class="form-control" :class="{ 'border-danger': errors.length }"
                                                        style="height: 50px;" />
                                                </Field>
                                                <ErrorMessage name="pays" class="text-danger mt-1" />
                                            </div>
                                            <div class="col-md-8">
                                                <Field name="telephone" v-slot="{ field }">
                                                    <div class="tel-input-fix">
                                                        <VueTelInput v-model="field.value" v-bind="field"
                                                            mode="international" :defaultCountry="selectedCountryCode"
                                                            :key="selectedCountryCode"
                                                            :inputOptions="{ placeholder: 'Entrez votre numéro de téléphone' }"
                                                            @on-input="onTelInput" />
                                                    </div>
                                                </Field>
                                                <ErrorMessage name="telephone" class="text-danger mt-1" />
                                            </div>
                                        </div>

                                        <!-- Étape 2  (infos légales + sécurité) -->
                                        <div v-show="currentStep === 2" class="row g-3">
                                            <div class="col-md-7">
                                                <div class="row g-3">
                                                    <div class="col-md-6">
                                                        <Field name="numfiscal" type="text" class="form-control"
                                                            placeholder="Numéro fiscal" />
                                                        <ErrorMessage name="numfiscal" class="text-danger" />
                                                    </div>
                                                    <div class="col-md-6">
                                                        <Field name="numRccm" type="text" class="form-control"
                                                            placeholder="Numéro RCCM" />
                                                        <ErrorMessage name="numRccm" class="text-danger" />
                                                    </div>
                                                    <div class="col-md-12">
                                                        <Field name="typeDocument" v-slot="{ field }">
                                                            <Multiselect :options="documentOptions"
                                                                v-model="field.value" v-bind="field"
                                                                placeholder="Selectionnez le Type de document" />
                                                        </Field>
                                                        <ErrorMessage name="typeDocument" class="text-danger" />
                                                    </div>
                                                    <div class="col-md-12 mt-4">
                                                        <!-- <label class="form-label">Message (facultatif)</label> -->
                                                        <Field name="message" v-slot="{ field }">
                                                            <textarea v-bind="field" class="form-control" rows="2"
                                                                placeholder="Ajoutez un message si vous le souhaitez..."></textarea>
                                                        </Field>
                                                        <ErrorMessage name="message" class="text-danger" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-5">
                                                <Field name="document" v-slot="{ field }">
                                                    <div id="myDropzone" class="dropzone custom-dropzone"
                                                        :class="{ 'disabled-dropzone': !registerForm?.values?.typeDocument }"
                                                        v-bind="field">
                                                        <div class="dz-message needsclick">
                                                            <i
                                                                class="bi bi-cloud-upload-fill fs-1 text-primary mb-3"></i>
                                                            <p class="mb-0">Déposez votre <strong>{{
                                                                selectedDocumentLabel }}</strong> ici<br>
                                                                <small class="text-muted">ou cliquez pour
                                                                    importer</small>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </Field>
                                                <p v-if="!registerForm?.values?.typeDocument"
                                                    class="text-muted text-center mt-2">
                                                    Veuillez d’abord sélectionner le type de document
                                                </p>
                                                <ErrorMessage name="document" class="text-danger" />
                                            </div>

                                            <div class="col-md-6">
                                                <div class="position-relative">
                                                    <Field name="password" :type="showPassword ? 'text' : 'password'"
                                                        class="form-control pe-5" placeholder="Mot de passe" />
                                                    <i class="bi password-eye position-absolute"
                                                        :class="showPassword ? 'bi-eye' : 'bi-eye-slash'"
                                                        @click="togglePassword"
                                                        style="top: 50%; right: 10px; transform: translateY(-50%); cursor: pointer;"></i>
                                                </div>
                                                <ErrorMessage name="password" class="text-danger mt-1" />
                                            </div>
                                            <div class="col-md-6">
                                                <div class="position-relative">
                                                    <Field name="confirm_password"
                                                        :type="showPassword ? 'text' : 'password'" class="form-control"
                                                        placeholder="Confirmer mot de passe" />
                                                    <i class="bi password-eye position-absolute"
                                                        :class="showPassword ? 'bi-eye' : 'bi-eye-slash'"
                                                        @click="togglePassword"
                                                        style="top: 50%; right: 10px; transform: translateY(-50%); cursor: pointer;"></i>
                                                </div>
                                                <ErrorMessage name="confirm_password" class="text-danger" />
                                            </div>
                                        </div>

                                        <!-- Étape 3 : Récapitulatif -->
                                        <div v-show="currentStep === 3" class="row g-3">
                                            <div class="col-12">
                                                <h5 class="mb-3">Récapitulatif de votre inscription</h5>
                                                <div class="recap-grid mb-3">
                                                    <div class="recap-item"><strong>Nom :</strong> {{
                                                        registerForm?.values.nom }}</div>
                                                    <div class="recap-item"><strong>Prénom :</strong> {{
                                                        registerForm?.values.prenom }}</div>
                                                    <div class="recap-item"><strong>Email :</strong> {{
                                                        registerForm?.values.email }}</div>
                                                    <div class="recap-item"><strong>Statut :</strong> {{
                                                        registerForm?.values.statut }}</div>
                                                    <div class="recap-item"><strong>Nom Organisation :</strong> {{
                                                        registerForm?.values.nomOrganisation }}</div>
                                                    <div class="recap-item"><strong>Site web :</strong> {{
                                                        registerForm?.values.siteweb }}</div>
                                                    <div class="recap-item"><strong>Adresse :</strong> {{
                                                        registerForm?.values.adresse }}</div>
                                                    <div class="recap-item"><strong>Ville :</strong> {{
                                                        registerForm?.values.ville }}</div>
                                                    <div class="recap-item"><strong>Code Postal :</strong> {{
                                                        registerForm?.values.codePostal }}</div>
                                                    <div class="recap-item"><strong>Pays :</strong> {{
                                                        registerForm?.values.pays }}</div>
                                                    <div class="recap-item"><strong>Téléphone :</strong> {{
                                                        registerForm?.values.telephone }}</div>
                                                    <div class="recap-item"><strong>Numéro fiscal :</strong> {{
                                                        registerForm?.values.numfiscal }}</div>
                                                    <div class="recap-item"><strong>Numéro RCCM :</strong> {{
                                                        registerForm?.values.numRccm }}</div>
                                                    <div class="recap-item"><strong>Type de document :</strong> {{
                                                        registerForm?.values.typeDocument }}</div>
                                                    <div class="recap-item"><strong>Message :</strong> {{
                                                        registerForm?.values.message }}</div>
                                                </div>

                                                <div class="alert alert-info">Veuillez vérifier vos informations avant
                                                    de valider votre inscription.</div>
                                            </div>
                                        </div>

                                        <!-- Boutons Étapes -->
                                        <div class="d-flex justify-content-between mt-3 mb-10">
                                            <button v-if="currentStep > 1" type="button" class="btn btn-secondary"
                                                @click="prevStep">Précédent</button>
                                            <button v-if="currentStep < totalSteps" type="button"
                                                class="btn btn-primary" @click="nextStep">Suivant</button>
                                            <button v-else type="submit" class="btn btn-success"> <span
                                                    v-if="isLoginDisabled">
                                                    Patientez {{ otpCode }} secondes
                                                </span>
                                                <span v-else>
                                                    Valider
                                                </span>
                                            </button>
                                        </div>
                                        <!-- <div v-if="currentStep === totalSteps">
                                            <p class="text-center">ou Inscrivez-vous avec ces plateformes</p>
                                            <div class="text-center social">
                                                <i class="bi bi-google"></i>
                                                <i class="bi bi-facebook"></i>
                                                <i class="bi bi-github"></i> <i class="bi bi-linkedin"></i>
                                            </div>
                                        </div> -->
                                    </div>
                                </Form>
                                <Form v-else ref="loginForm" @submit="onSubmitLogin" :validation-schema="loginSchema">
                                    <div class="form-box login-box">
                                        <div class="input-box mb-3">
                                            <div class="position-relative">
                                                <i class="bi bi-envelope me-5"></i>
                                                <Field name="email" type="text"
                                                    class="form-control shadow-none fs-md-15 text-black"
                                                    placeholder="Entrer votre email" />
                                            </div>
                                            <ErrorMessage name="email" class="text-danger" />
                                        </div>
                                        <div class="input-box mb-4">
                                            <div class="position-relative">
                                                <i class="bi bi-lock me-5"></i>
                                                <Field name="password" :type="showPassword ? 'text' : 'password'"
                                                    class="form-control shadow-none fs-md-15 text-black"
                                                    placeholder="Entrer votre mot de passe" />
                                                <i class="bi password-eye"
                                                    :class="showPassword ? 'bi-eye' : 'bi-eye-slash'"
                                                    @click="togglePassword"
                                                    style="top: 50%; right: 10px; transform: translateY(-50%); cursor: pointer;"></i>
                                            </div>
                                            <ErrorMessage name="password" class="text-danger" />
                                        </div>
                                        <button class="btn btn-primary btn-custom w-100" :disabled="isLoginDisabled">
                                            <span v-if="isLoginDisabled">
                                                Patientez {{ otpCode }} secondes
                                            </span>
                                            <span v-else>
                                                Connectez-vous
                                            </span></button>
                                        <!-- <router-link to="/changepassword" class="text-center">Mot de Passe oublié?</router-link> -->
                                    </div>
                                </Form>
                            </div>
                        </transition>

                    </div>
                </div>
            </div>
            <!-- RIGHT: Panel (texte et bouton dynamiques) -->
            <div class="panel">
                <h1 class="fw-bold text-center panel-title" style="color: white;">
                    {{ isLoginActive ? 'Bienvenue à nouveau' : 'Soyez le Bienvenue' }}
                </h1>
                <p class="panel-sub" style="color: white;">
                    {{ isLoginActive ? "Pas encore de compte ?" : "Avez-vous déjà un compte ?" }}
                </p>
                <button class="btn btn-light px-4" @click="toggleSlide">
                    {{ isLoginActive ? 'Inscrivez-vous' : 'Connectez-vous' }}
                </button>
            </div>
        </div>
    </div>
    <teleport to="body">
        <div v-if="showOtpModal" class="my-ultimate-otp-modal">

            <div class="my-ultimate-otp-card">
                <div class="header">
                    <h5 class="text-center">Vérification en deux étapes</h5>
                    <button type="button" class="btn-close" @click="showOtpModal = false">

                    </button>
                </div>
                <div class="body">
                    <p class="text-muted small mb-3">Entrez le code à 6 chiffres reçu par email</p>
                    <transition name="fade">
                        <div v-if="globalSuccess" class="alert alert-success d-flex align-items-center mb-4 rounded-3"
                            role="alert">
                            <i class="bi bi-check-circle-fill me-2"></i>
                            <div class="fw-medium">{{ globalSuccess }}</div>
                        </div>
                    </transition>
                    <transition name="fade">
                        <div v-if="globalError" class="alert alert-danger d-flex align-items-center mb-4 rounded-3"
                            role="alert">
                            <i class="bi bi-exclamation-triangle-fill me-2"></i>
                            <div class="fw-medium">{{ globalError }}</div>
                        </div>
                    </transition>
                    <!-- <input v-model="otp" type="text" inputmode="numeric" maxlength="6"
                        class="form-control form-control-lg text-center" @keyup.enter="verifyOtpLogin" autofocus /> -->
                    <!-- OTP INPUT – 6 cases horizontales (remplace ton ancien bloc) -->
                    <div class="otp-container">
                        <input v-for="i in 6" :key="i" v-model="otp[i - 1]" @input="jumpToNext(i)"
                            @keydown.backspace="jumpBack($event, i)" type="text" inputmode="numeric" maxlength="1"
                            class="otp-input" :ref="(el) => setOtpRef(el as Element | null, i - 1)" autocomplete="off"
                            @keyup.enter="verifyOtpLogin" @paste.prevent="handlePaste($event)" />

                    </div>
                </div>
                <div class="footer">
                    <button class="btn btn-outline-secondary" @click="showOtpModal = false">
                        Annuler
                    </button>
                    <button class="btn btn-outline-success" @click="sendOtp" :disabled="otpCode > 0">
                        <span v-if="otpCode === 0">Demander un nouveau code</span>
                        <span v-else>Réessayez dans {{ otpCode }}secondes</span>
                    </button>
                    <button class="btn btn-primary" @click="verifyOtpLogin" :disabled="otp.length !== 6">
                        Valider
                    </button>
                </div>


            </div>

        </div>
    </teleport>
    <teleport to="body">
        <div v-if="showRegisterOtpModal" class="my-ultimate-otp-modal">
            <div class="my-ultimate-otp-card">
                <div class="header">
                    <h5 class="text-center">Activez-votre compte pour pouvoir vous connecter!!!!</h5>
                    <button type="button" class="btn-close" @click="showRegisterOtpModal = false"></button>
                </div>
                <div class="body">
                    <p class="text-muted small mb-3">Entrez le code à 6 chiffres reçu par email</p>
                    <transition name="fade">
                        <div v-if="globalSuccess" class="alert alert-success d-flex align-items-center mb-4 rounded-3"
                            role="alert">
                            <i class="bi bi-check-circle-fill me-2"></i>
                            <div class="fw-medium">{{ globalSuccess }}</div>
                        </div>
                    </transition>

                    <!-- MESSAGE D'ERREUR GLOBAL (auto-disparition) -->
                    <transition name="fade">
                        <div v-if="globalError" class="alert alert-danger d-flex align-items-center mb-4 rounded-3"
                            role="alert">
                            <i class="bi bi-exclamation-triangle-fill me-2"></i>
                            <div class="fw-medium">{{ globalError }}</div>
                        </div>
                    </transition>
                    <!-- <input v-model="registerOtp" type="text" inputmode="numeric" maxlength="6"
                        class="form-control form-control-lg text-center" @keyup.enter="verifyOtpRegister" autofocus /> -->
                    <div class="otp-container">
                        <input v-for="i in 6" :key="i" v-model="registerOtp[i - 1]" @input="jumpNext(i)"
                            @keydown.backspace="jumpToBack($event, i)" type="text" inputmode="numeric" maxlength="1"
                            class="otp-input" :ref="(el) => setOtpRef(el as Element | null, i - 1)" autocomplete="off"
                            @keyup.enter="verifyOtpRegister" @paste.prevent="Pastehandle($event)" />

                    </div>
                </div>
                <div class="footer">
                    <button class="btn btn-outline-secondary" @click="showRegisterOtpModal = false">
                        Annuler
                    </button>
                    <button class="btn btn-outline-success" @click="sendOtp" :disabled="otpCode > 0">
                        <span v-if="otpCode === 0">Demander un nouveau code</span>
                        <span v-else>Réessayez dans {{ otpCode }}</span>
                    </button>
                    <button class="btn btn-primary" @click="verifyOtpRegister" :disabled="registerOtp.length !== 6">
                        Valider
                    </button>
                </div>
            </div>
        </div>
    </teleport>

</template>


<script lang="ts">
import { defineComponent, ref, onMounted, nextTick, onUnmounted, watch, computed } from "vue";
import { Form, Field, ErrorMessage, useForm } from "vee-validate";
import * as Yup from "yup";
import { useRoute, useRouter } from "vue-router";
import { useAuthStore } from '@/services/auth';
import Multiselect from '@vueform/multiselect'
import Dropzone from "dropzone";
import { VueTelInput } from 'vue3-tel-input'
import '../../../../node_modules/vue3-tel-input/dist/vue3-tel-input.css'
import Vue3CountryIntl from 'vue3-country-intl'
import '../../../../node_modules/vue3-country-intl/lib/vue3-country-intl.css'
import ApiService from "@/services/ApiService";
import type { FormContext } from "vee-validate";
import JwtService from "@/services/JwtService";

export default defineComponent({
    name: "AuthentificationForm",
    components: {
        Form,
        Field,
        ErrorMessage,
        Multiselect,
        VueTelInput,
        Vue3CountryIntl

        // DropZone

    },
    setup() {

        const loginSchema = Yup.object().shape({
            email: Yup.string().email("L'email est invalide").required('L\'email   est obligatoire'),
            password: Yup.string().min(8, 'Le mot de passe doit contenir au moins 8 caractères').required('Le mot de passe est obligatoire'),
        });

        const registerSchema = Yup.object({
            nom: Yup.string().required("Le nom est obligatoire"),
            prenom: Yup.string().required("Le prénom est obligatoire"),
            email: Yup.string().email("Email invalide").required("Veuillez renseigner votre email "),
            password: Yup.string().min(8, "Mot de passe min 8 caractères").required("Veuillez  saisir un mot de passe"),
            confirm_password: Yup.string()
                .oneOf([Yup.ref('password')], "Les mots de passe ne correspondent pas")
                .required("Confirmez votre mot de passe"),

            statut: Yup.string().required(" Veuillez selectionner un statut"),
            nomOrganisation: Yup.string().required("Veuillez entrer le nom de l'organisation"),
            telephone: Yup.string()
                .required("Entrez votre numéro de téléphone")
                .test("is-valid-phone", "Numéro invalide", value => typeof value === 'string' && value.trim().length > 0),
            adresse: Yup.string().required("Entrez votre adresse"),
            ville: Yup.string().required("Entrez votre ville de résidence"),
            codePostal: Yup.string().required("Entrez votre code Postal"),
            pays: Yup.string().required("Selectionnez votre pays"),
            typeDocument: Yup.string().required("Selectionnez le type de Document"),
            document: Yup.mixed()
                .required("Joindre la pièce justificative")
                .test("fileRequired", "Joindre la pièce justificative", (value) => {
                    return value !== null;
                })
        });

        const loginForm = ref<FormContext<any> | null>(null);
        const registerForm = ref<FormContext | null>(null);
        const telephone = ref("")
        // const telecopieur = ref("")
        const pays = ref("")
        const documentFile = ref<File | null>(null)
        const router = useRouter();
        const store = useAuthStore();
        const showOtpModal = ref(false);
        // const otp = ref("");
        const otp = ref<string[]>(Array(6).fill(""));
        const loginUserId = ref<number | null>(null); // stocke userId renvoyé par le backend
        const showRegisterOtpModal = ref(false);
        const registerUserId = ref<number | null>(null);
        const registerOtp = ref<string[]>(Array(6).fill(""));
        const isLoginDisabled = ref(false); // ← nouvelle ref
        const showPassword = ref(false)
        const selectedCountryCode = ref("");
        const togglePassword = () => {
            showPassword.value = !showPassword.value
        }

        const { values } = useForm()

        const selectedDocumentLabel = computed(() => {
            return registerForm.value?.values?.typeDocument || 'document'
        })




        const setOtpRef = (el: Element | null, index: number) => {
            // On force le bon type + on accède à .value car c’est un ref
            if (el instanceof HTMLInputElement) {
                boxes.value[index] = el;
            } else {
                boxes.value[index] = null;
            }
        };
        const currentStep = ref(1); // commence à l'étape 1
        const totalSteps = 3; // nombre total d'étapes (à ajuster)
        const steps = [
            ['nom', 'prenom', 'email', 'statut', 'nomOrganisation', 'siteweb', 'adresse', 'ville', 'codePostal', 'pays', 'telephone'],
            ['numfiscal', 'numRccm', 'password', 'confirm_password', 'typeDocument', 'document', 'message'],
        ];

        const globalError = ref<string | null>(null);
        const globalSuccess = ref<string | null>(null);
        const statutOptions = [
            { label: "Chargeur ou son représentant à l'international", value: "Chargeur ou son représentant à l'international" },
            { label: "Commissionnaire en Douane Agrée(CDA) Togolais", value: "Commissionnaire en Douane Agrée(CDA) Togolais" },

        ];

        const documentOptions = [
            { label: "Régistre de Commerce ou Equivalent", value: "Régistre de Commerce ou Equivalent" },
            { label: "Document d'identification Fisacle ou Equivalent", value: "Document d'identification Fisacle ou Equivalent" }
        ]

        const boxes = ref<(HTMLInputElement | null)[]>(Array(6).fill(null));

        // Fonction de focus super fiable
        const jumpToNext = async (currentIndex: number) => {
            const currentValue = otp.value[currentIndex - 1];

            // Si on a bien saisi un chiffre ET qu’on n’est pas à la dernière case
            if (currentValue && currentIndex < 6) {
                await nextTick(); // ATTENDS que Vue ait mis à jour les refs
                const nextInput = boxes.value[currentIndex]; // index 0 → case 2, etc.
                nextInput?.focus();
                nextInput?.select(); // optionnel : sélectionne le contenu (UX top)
            }
        };

        const handlePaste = (e: ClipboardEvent) => {
            const pasted = e.clipboardData?.getData('text')?.trim() || '';
            const digits = pasted.replace(/\D/g, '').slice(0, 6); // garde que les chiffres, max 6

            if (digits.length > 0) {
                // Remplit les 6 cases
                for (let i = 0; i < 6; i++) {
                    otp.value[i] = digits[i] || '';
                }

                // Focus sur la dernière case remplie (ou la suivante si incomplet)
                nextTick(() => {
                    const focusIndex = Math.min(digits.length, 5);
                    boxes.value[focusIndex]?.focus();

                    // Soumission automatique si 6 chiffres collés
                    if (digits.length === 6) {
                        verifyOtpLogin();
                    }
                });
            }
        };

        // Gestion du Backspace (effacer + revenir en arrière)
        const jumpBack = async (e: KeyboardEvent, currentIndex: number) => {
            if (e.key === 'Backspace' && !otp.value[currentIndex - 1] && currentIndex > 1) {
                await nextTick();
                const prevInput = boxes.value[currentIndex - 2];
                prevInput?.focus();
                prevInput?.select();
            }
        };

        // À l'ouverture de la modale
        watch(showOtpModal, (v) => {
            if (v) {
                otp.value = Array(6).fill('');
                // 6 espaces pour que v-model marche bien au début
                nextTick(() => boxes.value[0]?.focus());
            }
        });

        // Fonction de focus super fiable
        const jumpNext = async (currentIndex: number) => {
            const currentValue = registerOtp.value[currentIndex - 1];
            // Si on a bien saisi un chiffre ET qu’on n’est pas à la dernière case
            if (currentValue && currentIndex < 6) {
                await nextTick(); // ATTENDS que Vue ait mis à jour les refs
                const nextInput = boxes.value[currentIndex]; // index 0 → case 2, etc.
                nextInput?.focus();
                nextInput?.select(); // optionnel : sélectionne le contenu (UX top)
            }
        };

        const Pastehandle = (e: ClipboardEvent) => {
            const pasted = e.clipboardData?.getData('text')?.trim() || '';
            const digits = pasted.replace(/\D/g, '').slice(0, 6); // garde que les chiffres, max 6

            if (digits.length > 0) {
                // Remplit les 6 cases
                for (let i = 0; i < 6; i++) {
                    registerOtp.value[i] = digits[i] || '';
                }

                // Focus sur la dernière case remplie (ou la suivante si incomplet)
                nextTick(() => {
                    const focusIndex = Math.min(digits.length, 5);
                    boxes.value[focusIndex]?.focus();

                    // Soumission automatique si 6 chiffres collés
                    if (digits.length === 6) {
                        verifyOtpRegister();
                    }
                });
            }
        };

        // Gestion du Backspace (effacer + revenir en arrière)
        const jumpToBack = async (e: KeyboardEvent, currentIndex: number) => {
            if (e.key === 'Backspace' && !registerOtp.value[currentIndex - 1] && currentIndex > 1) {
                await nextTick();
                const prevInput = boxes.value[currentIndex - 2];
                prevInput?.focus();
                prevInput?.select();
            }
        };

        // À l'ouverture de la modale
        watch(showOtpModal, (v) => {
            if (v) {
                registerOtp.value = Array(6).fill('');
                // 6 espaces pour que v-model marche bien au début
                nextTick(() => boxes.value[0]?.focus());
            }
        });


        // Surveille l'ouverture des deux modales OTP
        watch(showOtpModal, (isOpen) => {
            if (isOpen) {
                startOtpCooldown(120);
            }
        });

        watch(showRegisterOtpModal, (isOpen) => {
            if (isOpen) {
                startOtpCooldown(120);
            }
        });
        watch(
            () => otp.value.join(""),
            (code) => {
                if (code.length === 6 && /^\d{6}$/.test(code)) {
                    // Petit délai pour laisser le dernier focus se faire (UX parfaite)
                    nextTick(() => {
                        verifyOtpLogin();
                    });
                }
            }
        );
        watch(
            () => registerOtp.value.join(""),
            (code) => {
                if (code.length === 6 && /^\d{6}$/.test(code)) {
                    // Petit délai pour laisser le dernier focus se faire (UX parfaite)
                    nextTick(() => {
                        verifyOtpRegister();
                    });
                }
            }
        );
        const otpCode = ref(0); // secondes restantes avant de pouvoir renvoyer
        let otpInterval: number | null = null;

        const startOtpCooldown = (seconds: number) => {
            otpCode.value = seconds;
            isLoginDisabled.value = true;

            if (otpInterval) clearInterval(otpInterval);

            otpInterval = window.setInterval(() => {
                if (otpCode.value > 0) {
                    otpCode.value--;
                } else {
                    clearInterval(otpInterval!);
                    otpInterval = null;
                    isLoginDisabled.value = false;
                }
            }, 1000);
        };

        const stopOtpCooldown = () => {
            if (otpInterval) {
                clearInterval(otpInterval);
                otpInterval = null;
            }
            otpCode.value = 0;
            isLoginDisabled.value = false;
        };



        const onTelInput = (tel: any) => {
            const value = tel.number?.international || ""
            telephone.value = value
            registerForm.value?.setFieldValue("telephone", value)
        }

        // const onCountryChange = (country: any) => {
        //     if (!country) return
        //     let name = typeof country === "string" ? country : country?.name || ""
        //     name = name.replace(/^"|"$/g, "").trim()
        //     pays.value = name
        //     registerForm.value?.setFieldValue("pays", name)
        // }

        const onCountryChange = (country: any) => {
            if (!country) return;
            let name = typeof country === "string" ? country : country?.name || "";
            name = name.replace(/^"|"$/g, "").trim();
            pays.value = name;
            registerForm.value?.setFieldValue("pays", name);
            selectedCountryCode.value = country?.iso2?.toLowerCase() || "bj";
            const dialCode = country?.dialCode ? `+${country.dialCode} ` : "";
            telephone.value = dialCode;
            registerForm.value?.setFieldValue("telephone", dialCode);
        };




        const nextStep = async () => {
            if (!registerForm.value) return;

            const fieldsToValidate = steps[currentStep.value - 1];

            let isStepValid = true;

            for (const field of fieldsToValidate) {
                const result = await registerForm.value.validateField(field);

                if (!result.valid) {
                    isStepValid = false;
                }
            }

            if (!isStepValid) {
                // au moins un champ invalide → on bloque
                return;
            }

            //tous les champs de l’étape sont valides
            if (currentStep.value < totalSteps) {
                currentStep.value++;
            }
        };


        const prevStep = () => {
            if (currentStep.value > 1) currentStep.value--;
        };

        const submitButton = ref<HTMLButtonElement | null>(null);

        const onSubmitLogin = async (values: any) => {
            // console.log("Login values:", values)
            // router.push({ name: "tableauBordPage" });
            console.log("SUBMIT CLICKED"); // ← ça doit s’afficher à chaque clic
            console.log("values:", values);
            globalError.value = null;
            globalSuccess.value = null;
            try {
                const response = await ApiService.post("/auth/login", {
                    email: values.email.toLowerCase().trim(),
                    password: values.password,
                });
                if (response.data.code === 200 && response.data.data?.userId) {
                    loginUserId.value = response.data.data.userId;
                    showOtpModal.value = true;
                    globalSuccess.value = "Un code OTP a été envoyé à votre email";
                    setTimeout(() => globalSuccess.value = null, 5000);
                    startOtpCooldown(120);
                    return; // très important
                }
                throw new Error(response.data.message || "Réponse inattendue du serveur");
            } catch (error: any) {
                const msg = error.response?.data?.message
                    || error.response?.data?.error
                    || error.message
                    || "Login échoué";
                if (error.response?.status === 403 && error.response?.data?.requireActivation) {
                    registerUserId.value = error.response.data.userId;
                    showRegisterOtpModal.value = true;
                    globalError.value = null;
                    globalSuccess.value = "Un nouveau code vient de vous être envoyé par email";
                    setTimeout(() => {
                        globalSuccess.value = null;
                    }, 5000);
                    return;
                } else {
                    globalError.value = msg;
                }
                if (loginForm.value) loginForm.value.setFieldValue("password", "");
            }
        };

        const sendOtp = async () => {
            // On prend l'ID qui est actif : soit loginUserId, soit registerUserId
            const userId = loginUserId.value || registerUserId.value;
            if (!userId) {
                globalError.value = "Impossible de renvoyer le code.";
                return;
            }
            try {
                await ApiService.post("/sendOtp", {
                    userId: userId,
                    purpose: loginUserId.value ? "login" : "inscription",  // ← on envoie le bon purpose
                    channel: "email"
                });

                globalSuccess.value = "Un nouveau code vous a été envoyé par email !";
                startOtpCooldown(120);
                otp.value = [];
                registerOtp.value = [];  // vide aussi l’autre champ au cas où
                globalError.value = null;
                setTimeout(() => globalSuccess.value = null, 5000);
            } catch (err: any) {
                const msg = err.response?.data?.message || "Erreur lors du renvoi";
                globalError.value = msg;

                // Si c'est le message d'attente de 2 min → on relance quand même le cooldown
                if (msg.includes("patienter") || msg.includes("minute")) {
                    startOtpCooldown(120);
                }
            }
        };
        const verifyOtpLogin = async () => {
            if (!loginUserId.value || otp.value.length !== 6) {
                globalError.value = "Veuillez saisir 6 chiffres";
                return;
            }

            try {
                console.log("Vérification OTP pour login avec userId: et OTP:", otp.value.join(""));
                const response = await ApiService.post("/verifyOtp", {
                    userId: loginUserId.value,
                    otp: otp.value.join(""),
                    purpose: "login"
                });

                if (response.data.code === 200 || response.data.success) {
                    const data = response.data.data || response.data;
                    // Stockage des tokens
                    localStorage.setItem("id_token", data.token || data.accessToken);
                    localStorage.setItem("refreshToken", data.refreshToken || "");
                    // Connexion dans le store
                    const authStore = useAuthStore();
                    authStore.login(data.user);
                    JwtService.saveUser(data.user.id);
                    JwtService.saveUserName(data.user.nom || data.user.prenom || "");
                    JwtService.setUserEmail(data.user.email || "");
                    JwtService.saveUserPhone(data.user.telephone || "");
                    localStorage.setItem("user_role", JSON.stringify(data.user.roles || []));
                    localStorage.setItem("user_privilege", JSON.stringify(data.user.permissions || []));
                    JwtService.saveRole(JSON.stringify(data.user.roles || []));
                    JwtService.savePrivilege(JSON.stringify(data.user.permissions || []));
                    // JwtService.saveRole(data.user.role || "");
                    // JwtService.savePrivilege(JSON.stringify(data.user_allprivilege || []));
                    const nomComplet = data.user.nom
                        ? `${data.user.nom} ${data.user.prenom || ''}`.trim()
                        : data.user.prenom || data.user.email;

                    globalSuccess.value = `Connexion réussie ! Bienvenue ${nomComplet} !`;
                    showOtpModal.value = false;
                    otp.value = Array(6).fill('');


                    // Redirection
                    setTimeout(() => {
                        router.push({ name: "tableauBordPage" });
                    }, 800);

                } else {
                    globalError.value = response.data.message || "Code OTP incorrect";
                    setTimeout(() => {
                        router.push({ name: "LoginPage" });
                    }, 800);
                }
            } catch (error: any) {
                globalError.value = error.response?.data?.message || "Code invalide ou expiré";
                console.error("Erreur vérification OTP:", error);
            }
        };

        const verifyOtpRegister = async () => {
            if (!registerUserId.value || registerOtp.value.length !== 6) {
                globalError.value = "Veuillez saisir 6 chiffres";
                return;
            }
            try {
                console.log("Vérification OTP pour l'inscription avec userId: et OTP:", registerOtp.value.join(""));
                const response = await ApiService.post("/verifyOptInscription", {
                    userId: registerUserId.value,
                    otp: registerOtp.value.join(""),
                    purpose: "inscription"
                });

                if (response.data.code === 200 || response.data.success) {
                    globalSuccess.value = "Compte activé avec succès ! Vous pouvez maintenant vous connecter.";
                    stopOtpCooldown();
                    showRegisterOtpModal.value = false;
                    registerOtp.value = [];
                    registerUserId.value = null;
                    isLoginActive.value = true;
                    currentStep.value = 1;
                    registerForm.value?.resetForm();
                    setTimeout(() => {
                        globalSuccess.value = null;
                    }, 3000);

                } else {
                    globalError.value = response.data.message || "Code OTP incorrect, Veuillez entrer un code valide...";
                }
            } catch (error: any) {
                globalError.value = error.response?.data?.message || "Code invalide ou expiré";
                console.error("Erreur vérification OTP", error);
            }
        };

        const onSubmitRegister = async (values: any) => {
            globalError.value = null;
            globalSuccess.value = null;
            try {
                const fd = new FormData();
                // Champs texte
                fd.append("nom", values.nom);
                fd.append("prenom", values.prenom);
                fd.append("email", values.email);
                fd.append("statut", values.statut);
                fd.append("nomOrganisation", values.nomOrganisation);
                fd.append("telephone", values.telephone);
                // fd.append("telecopieur", values.telecopieur);
                fd.append("adresse", values.adresse);
                fd.append("ville", values.ville);
                fd.append("codePostal", values.codePostal);
                fd.append("pays", values.pays);
                fd.append("siteweb", values.siteweb);
                fd.append("numfiscal", values.numfiscal);
                fd.append("typeDocument", values.typeDocument)
                fd.append("numRccm", values.numRccm);
                fd.append("confirm_password", values.confirm_password);
                fd.append("password", values.password);
                fd.append("message", values.message ?? "");

                // Document
                if (myDropzone?.files.length) {
                    fd.append("document", myDropzone.files[0]);
                }

                const response = await ApiService.postWithFile("/auth/register", fd)
                registerUserId.value = response.data.data.userId;
                console.log("Succès avec ApiService:", response);
                console.log("Inscription réussie:", response);

                globalSuccess.value = "Inscription réussie !!!! Poursuivons.";
                startOtpCooldown(120);
                showRegisterOtpModal.value = true;
                setTimeout(() => {
                    globalSuccess.value = null;
                }, 5000);


            } catch (error: any) {
                globalError.value =
                    error.response?.data?.message ||
                    "Erreur lors de l’inscription. Veuillez réessayer.";
            }
        };
        const isLoginActive = ref(true);

        const toggleSlide = () => {
            isLoginActive.value = !isLoginActive.value;
        };

        const dropzoneOptions = {
            url: '/upload', // endpoint pour ton upload
            maxFiles: 1,
            acceptedFiles: 'image',
            autoProcessQueue: false,
        };

        let myDropzone: Dropzone | null = null;

        // onMounted(() => {
        //     Dropzone.autoDiscover = false;

        //     myDropzone = new Dropzone("#myDropzone", {
        //         url: "#",
        //         autoProcessQueue: false,
        //         clickable: true,
        //         maxFiles: 1,
        //         acceptedFiles: "image/*,.pdf,.doc,.docx,.xls,.xlsx",
        //         dictDefaultMessage: "",
        //         dictRemoveFile: "Supprimer",
        //         addRemoveLinks: true,

        //         init: function (this: Dropzone) {
        //             const dropzoneElement = document.getElementById("myDropzone");
        //             const messageElement = dropzoneElement?.querySelector(".dz-message") as HTMLElement | null;

        //             this.on("addedfile", (file) => {
        //                 if (messageElement) messageElement.style.display = "none"
        //                 documentFile.value = file
        //                 registerForm.value?.setFieldValue("document", file)  // ← important
        //                 registerForm.value?.setFieldError("document", undefined)
        //             })

        //             this.on("removedfile", () => {
        //                 if (messageElement) messageElement.style.display = "block"
        //                 documentFile.value = null
        //                 registerForm.value?.setFieldValue("document", null)
        //             })

        //         }

        //     });
        // });

        watch(
            () => isLoginActive.value,
            (val) => {
                if (!val) {
                    nextTick(() => {
                        const dzElement = document.getElementById("myDropzone");
                        if (dzElement && !myDropzone) {
                            myDropzone = new Dropzone("#myDropzone", {
                                url: "#",
                                autoProcessQueue: false,
                                clickable: true,
                                maxFiles: 1,
                                acceptedFiles: "image/*,.pdf,.doc,.docx,.xls,.xlsx",
                                dictDefaultMessage: "",
                                dictRemoveFile: "Supprimer",
                                addRemoveLinks: true,
                                init: function (this: Dropzone) {
                                    const messageElement = dzElement.querySelector(".dz-message") as HTMLElement | null;

                                    this.on("addedfile", (file) => {
                                        if (messageElement) messageElement.style.display = "none";
                                        documentFile.value = file;
                                        registerForm.value?.setFieldValue("document", file);
                                        registerForm.value?.setFieldError("document", undefined);
                                    });

                                    this.on("removedfile", () => {
                                        if (messageElement) messageElement.style.display = "block";
                                        documentFile.value = null;
                                        registerForm.value?.setFieldValue("document", null);
                                    });
                                }
                            });
                        }
                    });
                }
            },
            { immediate: true }
        );

        watch(globalError, (newError) => {
            if (newError) {
                setTimeout(() => {
                    globalError.value = null;
                }, 5000); // 5 secondes
            }
        });

        // Efface l'erreur quand on change de formulaire (login ↔ register)
        watch(isLoginActive, () => {
            globalError.value = null;
        });

        // Nettoyage propre au destroy
        onUnmounted(() => {
            myDropzone?.destroy();
        });
        return {
            stopOtpCooldown,
            selectedDocumentLabel,
            sendOtp,
            isLoginActive,
            toggleSlide,
            onSubmitLogin,
            loginSchema,
            submitButton,
            registerSchema,
            onSubmitRegister,
            statutOptions,
            documentOptions,
            currentStep,
            prevStep,
            totalSteps,
            nextStep,
            otpCode,
            dropzoneOptions,
            telephone,
            // telecopieur,
            pays,
            verifyOtpRegister,
            globalError,
            onTelInput,
            onCountryChange,
            registerForm,
            globalSuccess,
            showOtpModal,
            verifyOtpLogin,
            otp,
            values,
            showRegisterOtpModal,
            registerOtp,
            isLoginDisabled,
            jumpToNext,
            jumpNext,
            jumpToBack,
            Pastehandle,
            jumpBack,
            boxes,
            setOtpRef,
            handlePaste,
            showPassword,
            togglePassword,
            selectedCountryCode



        };
    },
});
</script>

<style>
.recap-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px 24px;
}

.recap-item {
    background: #f8f9fa;
    border-radius: 8px;
    padding: 12px 16px;
    font-size: 1rem;
    border: 1px solid #e0e0e0;
    word-break: break-word;
}

@media (max-width: 700px) {
    .recap-grid {
        grid-template-columns: 1fr;
    }
}

/* Layout */
body {
    background: #dfe7f6;
    font-family: "Poppins", sans-serif;
}

.container-box {
    max-width: 1200px;
    width: 100%;
    background: white;
    border-radius: 25px;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    gap: 0;
    box-shadow: 0 5px 25px rgba(0, 0, 0, 0.1);
    min-height: 530px;
}

.form-header {
    flex: 0 0 auto;
    /* header reste fixe */
    text-align: center;
    padding-top: 15px !important;
    margin-top: 0 !important;
}

/* left column that contains the forms */
/* .forms-column {
    flex: 1;
    padding: 40px 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 700px;
    min-height: 600px;

} */
.forms-column {
    flex: 1;
    padding: 40px 30px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    transition: width 0.3s cubic-bezier(.4, 2, .6, 1), max-width 0.3s cubic-bezier(.4, 2, .6, 1);
    max-height: calc(100vh - 120px);
    overflow-y: auto;
}

.forms-column.register-wide {
    width: 1100px;
    max-width: 1100px;
}

.forms-column.login-narrow {
    width: 400px;
    max-width: 400px;
}

@media (max-width: 1200px) {
    .forms-column.register-wide {
        width: 100%;
        max-width: 100%;
    }
}

@media (max-width: 860px) {

    .forms-column.register-wide,
    .forms-column.login-narrow {
        width: 100%;
        max-width: 100%;
    }
}


.fo {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: stretch;
    position: relative;
    margin-top: auto;
    margin-bottom: auto;
    width: 100%;
}




.panel {
    width: 320px;
    background: #0b4899;
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 40px;
    position: relative;
    min-width: 260px;
    /* panel reste fixe */
}

/* Form boxes */
.form-box {
    transition: opacity 300ms ease, transform 300ms ease;
    width: 100%;
    /* avant c'était 350px */
    max-width: 1200px;

}

.form-content {
    flex: 1 1 auto;
    /* overflow-y: auto; */
    padding-right: 10px;

}

/* .login-box {
    min-height: 580px;
    display: flex !important;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 40px 20px;
    background: white;
}

.login-box>* {
    width: 100%;
    max-width: 420px;
    overflow: hidden;
} */

.register-box,
.login-box {
    background: white;
}

.logo-img {
    width: 200px;
    height: 50px;
    object-fit: contain;
    display: block;
    margin: 0 auto !important;
    /* supprime tout margin auto parasite */
    padding-top: 0 !important;
    transform: translateY(-15px);
}

/* Inputs */

.form-control {
    border-radius: 10px;
    padding-left: 0px;
    height: 44px;
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
    font-size: 1rem;
    transition: font-size 0.2s, height 0.2s;
}

@media (max-width: 1200px) {
    .form-control {
        font-size: 0.95rem;
        height: 40px;
    }
}

@media (max-width: 860px) {
    .form-control {
        font-size: 0.92rem;
        height: 38px;
    }
}

@media (max-width: 576px) {
    .form-control {
        font-size: 0.9rem;
        height: 36px;
        padding: 0.375rem 0.5rem;
    }
}

textarea.form-control {
    min-height: 130px !important;
}

/* icon inside input */
.input-box {
    position: relative;
    margin-bottom: 12px;
}

/* .input-box i {
    position: absolute;
    left: 5px;
    top: 50%;
    transform: translateY(-50%);

    color: gray;
} */

.input-box {
    position: relative;
}

.input-box {
    position: relative;
}

.input-box i {
    position: absolute;
    top: 0;
    height: 44px;
    display: flex;
    align-items: center;
    color: gray;
    pointer-events: none;
}

/* icônes à gauche (email, cadenas) */
.input-box i.bi-envelope,
.input-box i.bi-lock {
    left: 5px;
}

/* icône œil à droite */
.input-box .password-eye {
    right: 12px;
    left: auto !important;
    pointer-events: auto;
    cursor: pointer;
    z-index: 10;
}

.input-box .form-control {
    padding-left: 38px;
    padding-right: 38px;
}


/* Social icons */
.social i {
    font-size: 20px;
    border: 1px solid #ccc;
    padding: 8px 10px;
    border-radius: 8px;
    margin: 0 6px;
    transition: 0.2s;
    cursor: pointer;
}

/* Panel text */
.panel-title {
    font-size: 22px;
    margin-bottom: 8px;
}

.panel-sub {
    margin-bottom: 20px;
}

/* Responsive */
@media (max-width: 860px) {
    .container-box {
        max-width: 900px;
        width: 100%;
        background: white;
        border-radius: 25px;
        overflow: hidden;
        display: flex;
        gap: 0;
        box-shadow: 0 5px 25px rgba(0, 0, 0, 0.1);
        min-height: 530px !important;
    }

    .form-header {
        flex: 0 0 auto;
        /* header reste fixe */
        text-align: center;
        padding-top: 15px !important;
        margin-top: 0 !important;
    }
}

@media (min-width: 860px) {
    .container-box {
        min-height: 530px !important;
    }
}

/* left column that contains the forms */
/* .forms-column {
    flex: 1;
    padding: 40px 30px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 700px;
    max-height: 600px;

} */

.panel {
    width: 320px;
    background: #0b4899;
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 40px;
    position: relative;
    /* panel reste fixe */
}

.disabled-dropzone {
    opacity: 0.5;
    pointer-events: none;
    cursor: not-allowed;
}



.register-box,
.login-box {
    background: white;
}

.logo-img {
    width: 200px;
    height: 50px;
    object-fit: contain;
    display: block;
    margin: 0 auto !important;
    /* supprime tout margin auto parasite */
    padding-top: 0 !important;
    transform: translateY(-15px);
}

/* Inputs */
/* .form-control {
        border-radius: 10px;
        padding-left: 50px;
        height: 44px;
    } */

.form-control {
    height: 44px;
    padding-left: 50px;
    /* place pour email / cadenas */
    padding-right: 50px;
    /* place pour œil */
}


textarea.form-control {
    min-height: 130px !important;
}

/* icon inside input */
.input-box {
    position: relative;
    margin-bottom: 12px;
}

.input-box i {
    position: absolute;
    left: 5px;
    top: 50%;
    transform: translateY(-50%);

    color: gray;
}

/* Social icons */
.social i {
    font-size: 20px;
    border: 1px solid #ccc;
    padding: 8px 10px;
    border-radius: 8px;
    margin: 0 6px;
    transition: 0.2s;
    cursor: pointer;
}

/* Panel text */
.panel-title {
    font-size: 22px;
    margin-bottom: 8px;
}

.panel-sub {
    margin-bottom: 20px;
}

/* Responsive */
@media (max-width: 860px) {
    .container-box {
        flex-direction: column;
        border-radius: 16px;
        min-height: unset;
    }

    .forms-column {
        width: 100%;
        max-width: 100%;
        padding: 30px 10px;
        min-height: 400px;
    }

    .panel {
        width: 100%;
        min-width: unset;
        order: 3;
        border-radius: 0 0 16px 16px;
        padding: 30px 10px;
    }
}

@media (max-width: 576px) {
    .container-box {
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    }

    .forms-column {
        padding: 18px 2vw;
        min-height: 320px;
    }

    .panel {
        padding: 18px 2vw;
        border-radius: 0 0 8px 8px;
    }

    .form-header img.logo-img {
        width: 140px;
        height: 38px;
    }

    .form-header h3 {
        font-size: 1.2rem;
    }

    .form-box {
        max-width: 100%;
        padding: 0;
    }

    .stepper {
        gap: 6px;
    }
}

.slide-fade-enter-active,
.slide-fade-leave-active {
    transition: all 0.5s ease;
}

.slide-fade-enter-from {
    opacity: 0;
    transform: translateX(50%);
}

.slide-fade-leave-to {
    opacity: 0;
    transform: translateX(-50%);
}

.custom-dropzone {
    border: 2px dashed #9c9c9c;
    border-radius: 10px;
    background: #fafafa;
    padding: 20px;
    text-align: center;
    cursor: pointer;
    min-height: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
}

/* STEPPER STYLÉ */
.stepper {
    gap: 20px;
    flex-wrap: wrap;
}

.step {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    position: relative;
    flex: 1;
    max-width: 100px;
}

.step-circle {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #e0e0e0;
    color: #999;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 16px;
    transition: all 0.3s ease;
    border: 3px solid #e0e0e0;
}

.step.active .step-circle,
.step.completed .step-circle {
    background: #6f92f7;
    color: white;
    border-color: #6f92f7;
}

.step.completed .step-circle {
    background: #28a745;
    border-color: #28a745;
}

.step-label {
    font-size: 13px;
    color: #666;
    white-space: nowrap;
}

.step.active .step-label {
    color: #6f92f7;
    font-weight: 600;
}

.step-line {
    flex: 1;
    height: 2px;
    background: #e0e0e0;
    margin-top: 20px;
    transition: background 0.3s ease;
}

.step.active~.step .step-line,
.step.completed+.step-line {
    background: #6f92f7;
}

.step.completed+.step-line {
    background: #28a745;
}

/* Responsive */
@media (max-width: 576px) {
    .stepper {
        gap: 6px;
    }

    .step-label {
        font-size: 10px;
    }

    .step-circle {
        width: 28px;
        height: 28px;
        font-size: 12px;
    }
}

.tel-input-fix .vti__input {
    height: 40px;
    border-radius: 5px;
    /* border: 1px solid #ced4da; */
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
}

.alert-danger {
    background: #f8d7da;
    color: #721c24;
    border: none;
    padding: 14px 20px;
    font-size: 15px;
}

.fade-enter-active,
.fade-leave-active {
    transition: all 0.35s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
    transform: translateY(-10px);
}

.alert-success {
    background: #d1e7dd;
    color: #0f5132;
    border: none;
    padding: 14px 20px;
    font-size: 15px;
}

/* MODAL QUI MARCHE TOUJOURS – 100% indépendante */
.my-ultimate-otp-modal {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    background: rgba(0, 0, 0, 0.7) !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    z-index: 99999 !important;
    backdrop-filter: blur(8px) !important;
    -webkit-backdrop-filter: blur(8px) !important;
}

.my-ultimate-otp-card {
    background: white !important;
    border-radius: 16px !important;
    width: 95% !important;
    max-width: 500px !important;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.3) !important;
    overflow: hidden !important;
    animation: pop 0.3s ease-out !important;
}

.my-ultimate-otp-card .header {
    padding: 20px 24px 12px !important;
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
    border-bottom: 1px solid #eee !important;
}

.my-ultimate-otp-card .body {
    padding: 24px !important;
    text-align: center !important;
}

.my-ultimate-otp-card .footer {
    padding: 16px 24px !important;
    display: flex !important;
    justify-content: center !important;
    gap: 10px !important;
    /* Réduit */
    background: #f8f9fa !important;
    border-top: 1px solid #eee !important;
    /* justify-content: center; */
    min-width: 150px;
}

.my-ultimate-otp-card .footer .btn {
    padding: 8px 14px;
    /* réduit la taille */
    font-size: 14px;
    /* taille du texte */
    height: auto;

}

/* @media (max-width: 768px) {
        .my-ultimate-otp-card {
            width: 95% !important;
            max-width: 95% !important;
        }
    } */

@keyframes pop {
    from {
        transform: scale(0.8);
        opacity: 0;
    }

    to {
        transform: scale(1);
        opacity: 1;
    }
}

.otp-container {
    display: flex;
    gap: 12px;
    justify-content: center;
    margin: 20px 0;
}

.otp-input {
    width: 56px;
    height: 56px;
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    border: 2px solid #ddd;
    border-radius: 12px;
    transition: all 0.2s ease;
    background: white;
    color: #333;
}

.otp-input:focus {
    outline: none;
    border-color: #0b4899;
    box-shadow: 0 0 0 3px rgba(11, 72, 153, 0.15);
    transform: scale(1.05);
}

.otp-input:not(:empty) {
    border-color: #0b4899;
}

/* Mobile */
@media (max-width: 480px) {
    .otp-input {
        width: 48px;
        height: 48px;
        font-size: 20px;
    }

    .otp-container {
        gap: 8px;
    }
}
</style>
